import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dp-wrapper w-100" }
const _hoisted_2 = { class: "dp-label" }
const _hoisted_3 = ["value", "onFocus", "onBlur", "onInput"]

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    modelValue: {},
    deliveryPlan: {},
    label: {},
    minDate: { default: '' },
    maxDate: { default: '' },
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ValidationErrors, {
    messages: props.errorMessages
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(VueDatePicker), {
        class: "mt-1 with-label",
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        clearable: false,
        formats: { input: 'yyyy-MM-dd HH:mm' },
        locale: _unref(ja),
        enableSeconds: false,
        "time-config": { enableSeconds: true },
        "min-date": props.minDate,
        "max-date": props.maxDate,
        teleport: "body"
      }, {
        "dp-input": _withCtx(({ value, onInput, onFocus, onBlur }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(props.label), 1),
            _createElementVNode("input", {
              class: "dp-input",
              value: value,
              readonly: "",
              onFocus: onFocus,
              onBlur: onBlur,
              onInput: onInput
            }, null, 40, _hoisted_3)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "locale", "min-date", "max-date"])
    ]),
    _: 1
  }, 8, ["messages"]))
}
}

})